import React from "react";
import { Modal, Typography, Flex, Spin, Button } from "antd";
import { CarOutlined, UserOutlined } from "@ant-design/icons";
import { User } from "../models/User";

const { Title, Text } = Typography;
const BRAND       = "#00AF66";
const BRAND_LIGHT = "#E6F7EF";

interface Props {
    visible:           boolean;
    loadingDrivers:    boolean;
    noDriversFound:    boolean;
    availableDrivers:  User[];
    onClose:           () => void;
    onSelectDriver:    (driver: User) => void;
    onUseStandardRate: () => void;
    onWaitForDriver:   () => void;
}

const DriverSelectionModal: React.FC<Props> = ({
                                                   visible, loadingDrivers, noDriversFound, availableDrivers,
                                                   onClose, onSelectDriver, onUseStandardRate, onWaitForDriver,
                                               }) => {
    return (
        <Modal
            open={visible}
    onCancel={onClose}
    footer={null}
    centered
    width="92%"
    style={{ maxWidth: 440 }}
    destroyOnClose
    >
    <Title level={4} style={{ marginBottom: 16 }}>Select a Driver</Title>

    {loadingDrivers ? (
        <Flex vertical align="center" gap={12} style={{ padding: "40px 0" }}>
        <Spin size="large" />
        <Text type="secondary">Finding drivers near you…</Text>
    </Flex>
    ) : noDriversFound ? (
        <Flex vertical align="center" gap={12} style={{ padding: "24px 0 32px" }}>
        <CarOutlined style={{ fontSize: 32, color: "#BDBDBD" }} />
    <Text strong>No drivers available right now</Text>
    <Text type="secondary" style={{ textAlign: "center" }}>
        You can use the standard delivery rate or keep waiting for a driver to become available.
    </Text>
    </Flex>
    ) : (
        <Flex vertical gap={8} style={{ marginBottom: 20, maxHeight: 320, overflowY: "auto" }}>
        {availableDrivers.map(driver => (
            <Flex
                key={driver.id}
            align="center"
            justify="space-between"
            onClick={() => onSelectDriver(driver)}
            style={{
            padding: "12px 14px",
                borderRadius: 10,
                border: "1.5px solid #EDF1F7",
                cursor: "pointer",
        }}
        >
            <Flex align="center" gap={10}>
        <div style={{
            width: 36, height: 36, borderRadius: 10,
                background: BRAND_LIGHT, display: "flex",
                alignItems: "center", justifyContent: "center",
        }}>
            <UserOutlined style={{ color: BRAND }} />
        </div>
        <Text strong>{driver.name} {driver.surname}</Text>
        </Flex>
        <Text strong style={{ color: BRAND }}>R{driver.price}/5km</Text>
        </Flex>
        ))}
        </Flex>
    )}

    <Flex vertical gap={8}>
    <Button type="primary" block size="large" onClick={onUseStandardRate} style={{ background: BRAND, borderColor: BRAND }}>
    Use Standard Rate (R40/5km)
    </Button>
    {noDriversFound && (
        <Button block size="large" onClick={onWaitForDriver}>
        Keep Waiting
    </Button>
    )}
    </Flex>
    </Modal>
);
};

export default DriverSelectionModal;